// src/pages/mallkiosk/LanguageScreen.js
import React from 'react';

export default function LanguageScreen({ mall, onPick }) {
  return (
    <div style={{
      position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 40,
    }}>
      <div style={{ fontSize: 20, color: 'var(--text2)', marginBottom: 8 }}>{mall?.name}</div>
      <div style={{ fontSize: 42, fontWeight: 800, color: 'var(--text)', marginBottom: 60, textAlign: 'center' }}>
        Choose your language / اختر لغتك
      </div>

      <div style={{ display: 'flex', gap: 32 }}>
        <button
          onClick={() => onPick('en')}
          style={{
            width: 320, height: 220, borderRadius: 28, border: '2px solid var(--border)',
            background: 'var(--bg2)', color: 'var(--text)', fontSize: 36, fontWeight: 800, cursor: 'pointer',
          }}>
          🇬🇧<div style={{ marginTop: 12 }}>English</div>
        </button>
        <button
          onClick={() => onPick('ar')}
          style={{
            width: 320, height: 220, borderRadius: 28, border: '2px solid var(--border)',
            background: 'var(--bg2)', color: 'var(--text)', fontSize: 36, fontWeight: 800, cursor: 'pointer',
          }}>
          🇦🇪<div style={{ marginTop: 12 }}>العربية</div>
        </button>
      </div>
    </div>
  );
}
